import dayjs from "@/utils/dayjs";

export default class TimeFieldUtils {
  private static standard_time_format_date_part = "1970-01-01 ";
  private static standard_time_format = "1970-01-01 18:00:00.000";
  private static MS_HOUR = 60 * 60 * 1000;
  private static MS_MINUTES = 60 * 1000;
  private static MS_SECONDS = 60 * 1000;

  static formatTime(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any): any {
    if (!value)
      return '';
    let ms = dayjs(value).unix();
    let hours = Math.floor(ms / this.MS_HOUR);
    let minutes = Math.floor((ms % this.MS_HOUR) / this.MS_MINUTES);
    let seconds = Math.floor((ms % this.MS_MINUTES) / this.MS_SECONDS);
    let millis = (ms % this.MS_SECONDS);

    // console.log("format", value);
    if (value && value.length === this.standard_time_format.length) {
      let s = value.substring(this.standard_time_format_date_part.length);
      if (s.endsWith(".000"))
        s = s.substring(0, s.length - 4);
      if (s.endsWith(":00"))
        s = s.substring(0, s.length - 3);
      return s;
    }
    return '';
  }

  static timeToString(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any): string {
    // console.log("parse", value);
    if (!value)
      return '';
    let parts = value.split(/[:.]/);
    let s = this.standard_time_format_date_part;
    for (let i = 0; i < 4; i++) {
      let p = i >= parts.length ? 0 : parseInt(parts[i]);
      if (isNaN(p))
        p = 0;
      let len = 2;
      if (i == 3) {
        s += ".";
        len = 3;
      } else if (i > 0) {
        s += ":"
      }
      s += p.toString().padStart(len, "0");
    }
    return s;
  }
}
